module.exports = __webpack_public_path__ + "static/media/zcl.69550867.svg";